import { FC } from "react";
import Translate from "components/Translate/Translate";
import styled from "@emotion/styled";
import { CustomDialog } from "molecule/customDialog/CustomDialog";
import { CustomDialogHeading } from "molecule/customDialog/CustomDialogHeading";

const BehavioralCrisisWrapper = styled.div`
  padding: 1.5rem /* 24/16 */;
`;

const BehavioralCrisisText = styled.div`
  font-size: 0.875rem /* 14/16 */;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.0175rem /* -0.28/16 */;
`;

const BehavioralCrisisTextBold = styled.div`
  font-size: 0.875rem /* 14/16 */;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.0175rem /* -0.28/16 */;
  margin-top: 1rem /* 16/16 */;
`;

export const BehavioralCrisisHotlinePopup: FC = () => {
  return (
    <CustomDialog>
      <BehavioralCrisisWrapper>
        <CustomDialogHeading slot={"title"}>
          <Translate msg={"behavioralCrisisHotline.title"} />
        </CustomDialogHeading>
        <BehavioralCrisisText>
          <Translate msg={"behavioralCrisisHotline.message"} />
        </BehavioralCrisisText>
        <BehavioralCrisisTextBold>
          <Translate msg={"behavioralCrisisHotline.suicideAndLifeline"} />
        </BehavioralCrisisTextBold>
        <BehavioralCrisisText>
          <Translate msg={"behavioralCrisisHotline.callOrText"} />
        </BehavioralCrisisText>
        <BehavioralCrisisTextBold>
          <Translate msg={"behavioralCrisisHotline.amazonEmployee"} />
        </BehavioralCrisisTextBold>
        <BehavioralCrisisText>
          <Translate msg={"behavioralCrisisHotline.amazonCall"} />
        </BehavioralCrisisText>
      </BehavioralCrisisWrapper>
    </CustomDialog>
  );
};

export default BehavioralCrisisHotlinePopup;
